
















































helpers = require '../../../helpers.coffee'

view_model = {
  props:
    reference: null
    allow_send_at_immediately: false
    action: null
    actions: null
    flow: null

  data: ->
    send_at_kind: 'after'
    send_at: null
    delay_after_previous_step_amount: 1
    delay_after_previous_step_unit: 'days'
    undefined_time: false
    persisted: false

    pristine: true

  computed:
    show_send_at_field: ->
      @send_at_kind == "after" || @send_at_kind == "today"

    send_at_kind_options: ->
      [
        { value: 'immediately', text: this.capitalizeFirstLetter(this.$t('general.label.immediately')) }
        { value: 'after', text: this.capitalizeFirstLetter(this.$t('general.label.after')) }
        { value: 'today', text: this.capitalizeFirstLetter(this.$t('flows.options.timming.today')) }
      ]

    delay_after_previous_step_unit_options: ->
      [
        { value: 'days', text: this.capitalizeFirstLetter(this.$t('general.label.days')) }
        { value: 'weeks', text: this.capitalizeFirstLetter(this.$t('general.label.weeks')) }
        { value: 'months', text: this.capitalizeFirstLetter(this.$t('general.label.months')) }
      ]

    is_automatic_email_action: ->
      @action.type == 'EmailFlowAction' && !@flow.semi_automatic

    send_at_validations: ->
      validations = ['send_at']
      validations.push('required') if @is_automatic_email_action
      @send_at; @actions[@reference - 1]; @delay_after_previous_step_amount # to force vue recalculate
      if @send_at_kind == 'today'
        validations.push('today_send_at')
      else if (@send_at_kind == 'after' && parseInt(@delay_after_previous_step_amount) == 0) && @reference > 0
        previous_send_at = if @actions[@reference - 1].send_at_kind == 'immediately'
          (@flow.created_at && moment(@flow.created_at).format('HH:mm')) || moment().format('HH:mm')
        else if send_at = @actions[@reference - 1]?.send_at
          send_at = moment(send_at.format('HH:mm'), 'HH:mm')
          send_at.add(-send_at.utcOffset(), 'minutes').format('HH:mm')

        if previous_send_at
          previous_send_at = moment(previous_send_at, 'HH:mm')
          validations.push('after_zero') unless moment(@send_at, 'HH:mm').isAfter(previous_send_at.add(29, 'minutes'))

      validations.join('|')

  methods:
    capitalizeFirstLetter: (string) ->
      helpers.masks.capitalizeFirstLetter(string)

    validateAll: ->
      @errors.clear()
      for key, value of @fieldsToValidate()
        @$validator.validate(key, value)

      EventsBus.$emit 'flows-send-at-picker-errors', { @errors, @reference }

    publishChange: ->
      if @send_at_kind == 'immediately' || @send_at_kind == 'today'
        @delay_after_previous_step_amount = null
        @delay_after_previous_step_unit = null
        @send_at = null if @send_at_kind == 'immediately' && !@action.isPersisted()

      if @send_at_kind == 'after'
        @delay_after_previous_step_unit ?= 'days'
        @delay_after_previous_step_amount ?= 2

      @$emit 'change', { @send_at, @delay_after_previous_step_amount, @delay_after_previous_step_unit, @reference, @send_at_kind }

    revalidate: ->
      EventsBus.$emit 'validate-all' unless @pristine

    setSendAt: (data) ->
      return unless data.reference == @reference
      @delay_after_previous_step_unit = data.delay_after_previous_step_unit
      @delay_after_previous_step_amount = data.delay_after_previous_step_amount
      @send_at = data.send_at if data.send_at && !data.undefined_time
      @persisted = data.persisted
      @undefined_time = data.undefined_time
      @send_at_kind = if data.immediately
        'immediately'
      else if !(@delay_after_previous_step_unit) && (@send_at || @undefined_time)
        'today'
      else
        'after'

      @publishChange()

    fieldsToValidate: ->
      switch @send_at_kind
        when 'after' then { @delay_after_previous_step_amount, @delay_after_previous_step_unit, @send_at }
        when 'today' then { @send_at }
        when 'immediately' then {}

    todaySendAtValidator: ->
      validate: (value, args) =>
        return true if value?.length != 5
        sent_at_time = moment(value, 'HH:mm')
        return true if (!@flow.human_weekdays_to_send.includes(sent_at_time.day()) && (sent_at_time.isAfter(moment().add(30, 'minutes')) || sent_at_time.isSameOrBefore(moment())))
        false
      getMessage: (field, args) =>
        this.$t('flows.label.programaticTodaySendAction')

    afterZeroValidator: ->
      validate: (value, args) =>
        false
      getMessage: (field, args) =>
        this.$t('flows.label.programaticAfterZeroAction')

    sendAtValidator: ->
      validate: (value, args) =>
        return true if @send_at?.length != 5
        return true if @send_at_kind == 'immediately'
        sent_at_time = moment(value, 'HH:mm')
        sent_at_time.isValid()
      getMessage: (field, args) =>
        this.$t('flows.label.programaticSendAtAction')

    addCustomValidators: ->
      @$validator.remove('today_send_at')
      @$validator.extend('today_send_at', @todaySendAtValidator())
      @$validator.remove('after_zero')
      @$validator.extend('after_zero', @afterZeroValidator())
      @$validator.remove('send_at')
      @$validator.extend('send_at', @sendAtValidator())

  watch:
    send_at_kind: ->
      @publishChange()

    send_at: ->
      @publishChange()

    delay_after_previous_step_amount: ->
      @publishChange()

    delay_after_previous_step_unit: ->
      @publishChange()

  created: ->
    @errors.clear()
    @addCustomValidators()
    EventsBus.$on 'validate-all', @validateAll
    EventsBus.$on 'FlowSendAtPicker:Set', @setSendAt
    EventsBus.$emit 'FlowSendAtPicker:Created', { @reference }

  beforeDestroy: ->
    EventsBus.$off 'validate-all', @validateAll
    EventsBus.$off 'FlowSendAtPicker:Set', @setSendAt
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flow_actions/picker/send_at.vue